import { render, staticRenderFns } from "./ConnectChatBotToWebsite.vue?vue&type=template&id=5332e84d&scoped=true&"
import script from "./ConnectChatBotToWebsite.vue?vue&type=script&lang=js&"
export * from "./ConnectChatBotToWebsite.vue?vue&type=script&lang=js&"
import style0 from "./ConnectChatBotToWebsite.vue?vue&type=style&index=0&id=5332e84d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5332e84d",
  null
  
)

export default component.exports